<template>
    <div>
         <breadCrumb 
            :icon="'fa-percent'"
            :category="$t(`sideNav.navSalonMenu`)"
            :subCategory="$t(`subMenu.salon_menu_discount`)"
            :subSubCategory="''">
        </breadCrumb>
        <ul class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
            <li class="nav-item" v-for="t in tab" :key="t.id">
                <a class="nav-link  bg-transparent fs-lg fw-400" :class="{'active': selectedTab == t.id}" @click="renderTabs(t.id)">{{t.text}}</a>
            </li>
        </ul>
        <div class="tab-content mt-5">
            <discountList ref="discountList" :class="{'active': selectedTab === 'main'}" class="tab-pane"></discountList>
            <discountSubCategoryList ref="discountSubCategoryList" :class="{'active': selectedTab === 'sub'}" class="tab-pane"></discountSubCategoryList>
        </div>
    </div>
</template>

<script>
import BreadCrumb from './../../Bread_Crumb'
import {setSalonMenuTabLabel} from './../../../../assets/js/dashboard/dashboard'
import DiscountList from './Discount_List'
import DiscountSubCategoryList from './Discount_SubCategoryList'

export default {
    name: 'menuDiscount',
    components:{
        DiscountList, DiscountSubCategoryList, BreadCrumb
    },
    data(){
        return{
            tab: [], selectedTab: 'main'
        }
    },
    watch:{
        "$i18n.locale"(val){
            this.setTabLabel()
        }
    },
    methods:{
        renderTabs(id){
            this.selectedTab = id;
            this.$refs.discountList.addDiscountToggle = false;
            this.$refs.discountSubCategoryList.addSubToggle = false;
        },
        setTabLabel(){
            this.tab = setSalonMenuTabLabel(this.$i18n.t('subMenu.salon_menu_discount'), this.$i18n.t('header.subCategory', {'item': this.$i18n.t('subMenu.salon_menu_discount')}))
        }
    },
    mounted(){
        let $vm = this
        $vm.setTabLabel()
    }
}
</script>
<style scoped>
.nav-link{
    cursor: pointer;
}
</style>